// import { motion } from "framer-motion";
// import { useState } from "react";
// import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
// import "../css/ContactSection.css";

// const ContactSection = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     location: "",
//     expertise: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Form Data Submitted:", formData);
//   };

//   return (
//     <section className="techvision-admin-landing-contact-section">
//       {/* LEFT SIDE */}
//       <motion.div
//         className="techvision-admin-landing-contact-left"
//         initial={{ opacity: 0, x: -80 }}
//         whileInView={{ opacity: 1, x: 0 }}
//         transition={{ duration: 1, ease: "easeOut" }}
//         viewport={{ once: true }}
//       >
//         <h2>
//           <span className="techvision-admin-landing-blue-text">Connect </span>
//           with Our <br /> Next-Gen{" "}
//           <span className="techvision-admin-landing-blue-text">Experts</span>
//         </h2>
//         <p>
//           Transform your ideas into reality with our dynamic team of innovators
//           and creators.
//         </p>

//         <div className="techvision-admin-landing-contact-info">
//           <p>
//             <FaPhoneAlt /> 713.953.5200
//           </p>
//           <p>
//             <FaEnvelope /> lja@lja.com
//           </p>
//           <p>
//             <FaMapMarkerAlt /> Global Locations
//           </p>
//         </div>

//         <motion.div
//           className="techvision-admin-landing-team-box"
//           whileHover={{ scale: 1.05 }}
//           transition={{ type: "spring", stiffness: 200 }}
//         >
//           <h4>Want to Join Our Future-Ready Team?</h4>
//           <a href="/" className="techvision-admin-landing-job-board-btn">
//             🚀 VISIT OUR JOB BOARD
//           </a>
//         </motion.div>
//       </motion.div>

//       {/* RIGHT SIDE FORM */}
//       <motion.div
//         className="techvision-admin-landing-contact-right"
//         initial={{ opacity: 0, x: 80 }}
//         whileInView={{ opacity: 1, x: 0 }}
//         transition={{ duration: 1, ease: "easeOut" }}
//         viewport={{ once: true }}
//         whileHover={{ rotateY: 5, rotateX: 2 }}
//       >
//         <form onSubmit={handleSubmit}>
//           <div className="techvision-admin-landing-form-row">
//             <div className="techvision-admin-landing-input-group">
//               <input
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//               />
//               <label>Full Name</label>
//             </div>
//             <div className="techvision-admin-landing-input-group">
//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//               <label>Email Address</label>
//             </div>
//           </div>

//           <div className="techvision-admin-landing-form-row">
//             <div className="techvision-admin-landing-input-group">
//               <input
//                 type="text"
//                 name="phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//               />
//               <label>Phone Number</label>
//             </div>
//             <div className="techvision-admin-landing-input-group">
//               <input
//                 type="text"
//                 name="location"
//                 value={formData.location}
//                 onChange={handleChange}
//               />
//               <label>Location</label>
//             </div>
//           </div>

//           <div className="techvision-admin-landing-input-group">
//             <select
//               name="expertise"
//               value={formData.expertise}
//               onChange={handleChange}
//             >
//               <option value="">Select Expertise</option>
//               <option value="engineering">Engineering</option>
//               <option value="design">Design</option>
//               <option value="ai">Artificial Intelligence</option>
//             </select>
//             <label>Expertise</label>
//           </div>

//           <div className="techvision-admin-landing-input-group">
//             <textarea
//               name="message"
//               value={formData.message}
//               onChange={handleChange}
//               required
//             />
//             <label>Tell Us About Your Project</label>
//           </div>

//           <motion.button
//             type="submit"
//             className="techvision-admin-landing-submit-btn"
//             whileHover={{ scale: 1.08, boxShadow: "0 0 20px #0076ffaa" }}
//             whileTap={{ scale: 0.95 }}
//           >
//             SUBMIT →
//           </motion.button>
//         </form>
//       </motion.div>
//     </section>
//   );
// };

// // export default ContactSection;
// import { motion } from "framer-motion";
// import { useState, useEffect } from "react";
// import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
// import axios from "axios";
// import { parse } from "tldts";
// import "../css/ContactSection.css";

// const ContactSection = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     location: "",
//     expertise: "",
//     message: "",
//   });

//   const [company, setCompany] = useState({
//     name: "",
//     contact: "",
//     email: "",
//     address: "",
//     logo: null,
//     favicon: null,
//     domain: "",
//     subdomain: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Form Data Submitted:", formData);
//   };

//   // Get domain info
//   const getDomainInfo = () => {
//     const hostname = window.location.hostname;
//     const parsed = parse(hostname);
//     return {
//       domain: parsed.domainWithoutSuffix || "",
//       subdomain: parsed.subdomain || "",
//     };
//   };

//   // Fetch company info dynamically
//   useEffect(() => {
//     const fetchCompany = async () => {
//       try {
//         const { domain } = getDomainInfo();
//         const response = await axios.get("https://payyug.in/api/get-company", {
//           params: { domain },
//         });
//         const data = response.data;

//         if (data && Object.keys(data).length > 0) {
//           setCompany({
//             name: data.name || "",
//             address: data.address || "",
//             phone: data.contact || "",
//             email: data.email || "",
//             logo: data.logo || null,
//             favicon: data.favicon || null,
//             domain: data.domain || "",
//             subdomain: data.subdomain || "",
//           });
//         }
//       } catch (err) {
//         console.error("Error fetching company info:", err);
//       }
//     };

//     fetchCompany();
//   }, []);

//   return (
//     <section className="techvision-admin-landing-contact-section">
//       {/* LEFT SIDE */}
//       <motion.div
//         className="techvision-admin-landing-contact-left"
//         initial={{ opacity: 0, x: -80 }}
//         whileInView={{ opacity: 1, x: 0 }}
//         transition={{ duration: 1, ease: "easeOut" }}
//         viewport={{ once: true }}
//       >
//         <h2>
//           <span className="techvision-admin-landing-blue-text">Connect </span>
//           with Our <br /> Next-Gen{" "}
//           <span className="techvision-admin-landing-blue-text">Experts</span>
//         </h2>
//         <p>
//           Transform your ideas into reality with our dynamic team of innovators
//           and creators.
//         </p>

//         <div className="techvision-admin-landing-contact-info">
//           <p>
//             <FaPhoneAlt /> {company.phone || "713.953.5200"}
//           </p>
//           <p>
//             <FaEnvelope /> {company.email || "lja@lja.com"}
//           </p>
//           <p>
//             <FaMapMarkerAlt /> {company.address || "address"}
//           </p>
//         </div>

//         <motion.div
//           className="techvision-admin-landing-team-box"
//           whileHover={{ scale: 1.05 }}
//           transition={{ type: "spring", stiffness: 200 }}
//         >
//           <h4>Want to Join Our Future-Ready Team?</h4>
//           <a href="/" className="techvision-admin-landing-job-board-btn">
//             🚀 VISIT OUR JOB BOARD
//           </a>
//         </motion.div>
//       </motion.div>

//       {/* RIGHT SIDE FORM */}
//       <motion.div
//         className="techvision-admin-landing-contact-right"
//         initial={{ opacity: 0, x: 80 }}
//         whileInView={{ opacity: 1, x: 0 }}
//         transition={{ duration: 1, ease: "easeOut" }}
//         viewport={{ once: true }}
//         whileHover={{ rotateY: 5, rotateX: 2 }}
//       >
//         <form onSubmit={handleSubmit}>
//           <div className="techvision-admin-landing-form-row">
//             <div className="techvision-admin-landing-input-group">
//               <input
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//               />
//               <label>Full Name</label>
//             </div>
//             <div className="techvision-admin-landing-input-group">
//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//               <label>Email Address</label>
//             </div>
//           </div>

//           <div className="techvision-admin-landing-form-row">
//             <div className="techvision-admin-landing-input-group">
//               <input
//                 type="text"
//                 name="phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//               />
//               <label>Phone Number</label>
//             </div>
//             <div className="techvision-admin-landing-input-group">
//               <input
//                 type="text"
//                 name="location"
//                 value={formData.location}
//                 onChange={handleChange}
//               />
//               <label>Location</label>
//             </div>
//           </div>

//           <div className="techvision-admin-landing-input-group">
//             <select
//               name="expertise"
//               value={formData.expertise}
//               onChange={handleChange}
//             >
//               <option value="">Select Expertise</option>
//               <option value="engineering">Engineering</option>
//               <option value="design">Design</option>
//               <option value="ai">Artificial Intelligence</option>
//             </select>
//             <label>Expertise</label>
//           </div>

//           <div className="techvision-admin-landing-input-group">
//             <textarea
//               name="message"
//               value={formData.message}
//               onChange={handleChange}
//               required
//             />
//             <label>Tell Us About Your Project</label>
//           </div>

//           <motion.button
//             type="submit"
//             className="techvision-admin-landing-submit-btn"
//             whileHover={{ scale: 1.08, boxShadow: "0 0 20px #0076ffaa" }}
//             whileTap={{ scale: 0.95 }}
//           >
//             SUBMIT →
//           </motion.button>
//         </form>
//       </motion.div>
//     </section>
//   );
// };

// export default ContactSection;


import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import axios from "axios";
import { parse } from "tldts";
import "../css/ContactSection.css";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    expertise: "",
    message: "",
  });

  const [company, setCompany] = useState({
    name: "Your Company",
    contact: "713.953.5200",
    email: "lja@lja.com",
    address: "Default Address",
    logo: null,
    favicon: null,
    domain: "",
    subdomain: "",
  });

  const [fetchError, setFetchError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
  };

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);
    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  // Fetch company info dynamically
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const { domain } = getDomainInfo();
        const response = await axios.get("https://payyug.in/api/get-company", {
          params: { domain },
        });

        const data = response.data;
        if (data && Object.keys(data).length > 0) {
          setCompany({
            name: data.name || company.name,
            address: data.address || company.address,
            contact: data.contact || company.contact,
            email: data.email || company.email,
            logo: data.logo || company.logo,
            favicon: data.favicon || company.favicon,
            domain: data.domain || company.domain,
            subdomain: data.subdomain || company.subdomain,
          });

          // Set favicon dynamically
          if (data.favicon) {
            const link =
              document.querySelector("link[rel*='icon']") ||
              document.createElement("link");
            link.type = "image/png";
            link.rel = "icon";
            link.href = `https://payyug.in/${
              data.favicon.startsWith("images/")
                ? data.favicon.slice(7)
                : data.favicon
            }`;
            document.head.appendChild(link);
          }
        } else {
          setFetchError("Company info not found.");
        }
      } catch (err) {
        console.error("Error fetching company info:", err);
        setFetchError("Failed to fetch company info.");
      }
    };

    fetchCompany();
  }, []);

  return (
    <section className="techvision-admin-landing-contact-section">
      {/* LEFT SIDE */}
      <motion.div
        className="techvision-admin-landing-contact-left"
        initial={{ opacity: 0, x: -80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <h2>
          <span className="techvision-admin-landing-blue-text">Connect </span>
          with Our <br /> Next-Gen{" "}
          <span className="techvision-admin-landing-blue-text">Experts</span>
        </h2>
        <p>
          Transform your ideas into reality with our dynamic team of innovators
          and creators.
        </p>

        {fetchError && (
          <p className="contact-fetch-error">{fetchError}</p>
        )}

        <div className="techvision-admin-landing-contact-info">
          <p>
            <FaPhoneAlt /> {company.contact}
          </p>
          <p>
            <FaEnvelope /> {company.email}
          </p>
          <p>
            <FaMapMarkerAlt /> {company.address}
          </p>
        </div>

        <motion.div
          className="techvision-admin-landing-team-box"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <h4>Want to Join Our Future-Ready Team?</h4>
          <a href="/" className="techvision-admin-landing-job-board-btn">
            🚀 VISIT OUR JOB BOARD
          </a>
        </motion.div>
      </motion.div>

      {/* RIGHT SIDE FORM */}
      <motion.div
        className="techvision-admin-landing-contact-right"
        initial={{ opacity: 0, x: 80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
        whileHover={{ rotateY: 5, rotateX: 2 }}
      >
        <form onSubmit={handleSubmit}>
          <div className="techvision-admin-landing-form-row">
            <div className="techvision-admin-landing-input-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <label>Full Name</label>
            </div>
            <div className="techvision-admin-landing-input-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <label>Email Address</label>
            </div>
          </div>

          <div className="techvision-admin-landing-form-row">
            <div className="techvision-admin-landing-input-group">
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
              <label>Phone Number</label>
            </div>
            <div className="techvision-admin-landing-input-group">
              <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
              />
              <label>Location</label>
            </div>
          </div>

          <div className="techvision-admin-landing-input-group">
            <select
              name="expertise"
              value={formData.expertise}
              onChange={handleChange}
            >
              <option value="">Select Expertise</option>
              <option value="Sales officer ">Sales officer </option>
              <option value="Business Development Executive ">Business Development Executive </option>
              <option value="Assistant Branch Manager">Assistant Branch Manager</option>
            </select>
            <label>Expertise</label>
          </div>

          <div className="techvision-admin-landing-input-group">
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <label>Tell Us About Your Project</label>
          </div>

          <motion.button
            type="submit"
            className="techvision-admin-landing-submit-btn"
            whileHover={{ scale: 1.08, boxShadow: "0 0 20px #0076ffaa" }}
            whileTap={{ scale: 0.95 }}
          >
            SUBMIT →
          </motion.button>
        </form>
      </motion.div>
    </section>
  );
};

export default ContactSection;
